import {
    AppBar,
    Button,
    IconButton,
    Toolbar,
    Typography,
    Box
} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import Settings from '@mui/icons-material/Settings';
import KeyIcon from '@mui/icons-material/Key';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { Person as PersonIcon } from '@mui/icons-material';
// import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { doLogout, setDrawer, changePage } from '../../actions'
import * as routes from '../../routes'
import { AppState } from 'src/store'
import { User } from 'src/auth'
import { globalProps } from 'src/config'


// const useStyles = makeStyles(theme => ({
//     appBar: {
//         zIndex: theme.zIndex.drawer + 1,
//         transition: theme.transitions.create(['width', 'margin'], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//         }),
//     },
//     menuButton: {
//         marginRight: theme.spacing(2),
//     },
//     title: {
//         flexGrow: 1,
//     },
// }))

const UserName: React.FC<{ user: User }> = ({ user }) => {
    const { username } = user;
    const isRoot = user.root;
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const goToChangePassword = () => {
        dispatch(changePage(routes.ROUTECHANGEPASSWORD));
        handleClose();
    }

    return <>
        <IconButton color="inherit" onClick={handleClick}><PersonIcon fontSize='small' /></IconButton>
        <Box sx={{ lineHeight: '2em', mr: 1 }}>
            {isRoot && <Typography variant="button"><i>{username}</i></Typography>}
            {!isRoot && <Typography variant="button">{username}</Typography>}
        </Box>
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        /* Triangle pointer */

                        // '&::before': {
                        //     content: '""',
                        //     display: 'block',
                        //     position: 'absolute',
                        //     top: 0,
                        //     right: 14,
                        //     width: 10,
                        //     height: 10,
                        //     bgcolor: 'background.paper',
                        //     transform: 'translateY(-50%) rotate(45deg)',
                        //     zIndex: 0,
                        // },
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem onClick={goToChangePassword}>
                <ListItemIcon>
                    <KeyIcon fontSize="small" />
                </ListItemIcon>
                {'Change Password'}
            </MenuItem>
            <MenuItem onClick={handleClose}>
                <ListItemIcon>
                    <Settings fontSize="small" />
                </ListItemIcon>
                {'Settings'}
            </MenuItem>
        </Menu>
    </>
}

const Header: React.FC = () => {
    const dispatch = useDispatch()
    // const classes = useStyles()
    const pageTitle = useSelector((state: AppState) => state.global.view.pageTitle)
    const globalViewOpts = useSelector((state: AppState) => state.global.view);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const loginState = useSelector((state: AppState) => state.global.login);
    const authorized = (loginState.token != null);
    const user = authorized ? loginState.token!.user : null;

    // useEffect(() => {
    //     if (loginState.token === null) {
    //         dispatch(changePage(routes.ROUTEHOME));
    //     }
    // }, [loginState.token]);

    const openDrawer = () => {
        dispatch(setDrawer(true))
    }

    const logout = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault()
        dispatch(doLogout())
    }

    const login = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault()
        dispatch(changePage(routes.ROUTELOGIN))
    }

    const signUp = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(routes.ROUTESIGNUP));
    }

    const landing = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(routes.ROUTEHOME));
    }

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                boxShadow: theme => theme.shadows[1]
            }}
        >
            <Toolbar
                sx={{
                    width: "100%",
                    maxWidth: authorized ? undefined : 1070,
                    mx: "auto"
                }}
            >
                {
                    authorized ? <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton> : <AccountTreeIcon sx={{ mr: 1, color: theme => theme.palette.secondary.light }} />
                }
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    <Typography display={'inline'} onClick={landing} sx={{ cursor: 'pointer' }}>{globalProps.getTitle()}</Typography> <Typography display={'inline'} marginLeft={1}>{globalViewOpts.pageTitle}</Typography>
                </Typography>
                {authorized ?
                    <>
                        <UserName user={user!} />
                        <IconButton color="inherit" onClick={logout}>
                            <LogoutIcon fontSize='small' />
                        </IconButton>
                    </>
                    :
                    <>
                        <Button color="inherit" onClick={signUp} size='small' sx={{ fontWeight: 'bold' }}>Sign Up</Button>
                        <Button color="inherit" onClick={login} size='small' sx={{ fontWeight: 'bold' }}>Login</Button>
                    </>
                }
            </Toolbar>
        </AppBar>
    )

}

export default Header
